import { render, staticRenderFns } from "./TransitionPreview.vue?vue&type=template&id=4b5ee569&"
import script from "./TransitionPreview.vue?vue&type=script&lang=js&"
export * from "./TransitionPreview.vue?vue&type=script&lang=js&"
import style0 from "./TransitionPreview.vue?vue&type=style&index=0&id=4b5ee569&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports